import React from 'react';
import { Table, Dropdown, Icon, Card, CopyToClipboardLink } from '@weezevent/nacre';
import LoadingTable from '../../../components/loadingTable';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Style from './contingentList.module.css';

function HeaderRow() {
    const { t } = useTranslation();

    return (
        <Table.Tr isHeader className={Style['contingent-table-header']}>
            <th className={Style['th-name']}>{t('ticket.charts.contingents.list.header.contingent')}</th>
            <th>{t('ticket.charts.contingents.list.header.color')}</th>
            <th>{t('ticket.charts.contingents.list.header.rate-quantity')}</th>
            <th>{t('ticket.charts.contingents.list.header.actions')}</th>
        </Table.Tr>
    );
}

function ContingentRow({ contingent, chartId, organization, onContingentDeleted }) {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Table.Tr
            style={{
                boxShadow: `inset 8px 0px 0px ${contingent.color}`
            }}
            className={Style['tr-body']}
            onClick={() => history.push(`/ticket/O${organization.id}/charts/${chartId}/contingents/${contingent.uuid}`)}
        >
            <Table.Td className={Style['td-name']}>{contingent.name}</Table.Td>
            <Table.Td>
                <div className={Style['td-copy']} onClick={e => e.stopPropagation()}>
                    <CopyToClipboardLink delay={1000} tooltipMini value={contingent.color} tooltip={t('ticket.common.action.copy')}>
                        {contingent.color}
                    </CopyToClipboardLink>
                </div>
            </Table.Td>
            <Table.Td>{contingent.rates.length || '0'}</Table.Td>
            <Table.CellDropdown>
                <Dropdown.Item item={t('ticket.common.action.edit')} onClick={() => history.push(`/ticket/O${organization.id}/charts/${chartId}/contingents/${contingent.uuid}`)} />
                <Dropdown.Line />
                <Dropdown.Item deleteItem disabled={contingent?.has_bookings} item={t('ticket.common.action.delete')} onClick={() => onContingentDeleted(contingent)} />
            </Table.CellDropdown>
        </Table.Tr>
    );
}

export default function ContingentTable({ contingents, chartId, organization, loadingContingents, onContingentDeleted, inputSearchValue }) {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <>
            <Table useNew className={Style['contingent-table']}>
                <Table.THead>
                    <HeaderRow />
                </Table.THead>
                <Table.TBody>
                    {contingents?.length > 0 && (
                        <>
                            {contingents.map(contingent => (
                                <ContingentRow
                                    key={contingent.uuid}
                                    chartId={chartId}
                                    organization={organization}
                                    contingent={contingent}
                                    onContingentDeleted={onContingentDeleted}
                                />
                            ))}
                        </>
                    )}
                </Table.TBody>
            </Table>
            <LoadingTable loading={loadingContingents} />
            {!loadingContingents && !contingents?.length && (
                <Card.EmptyState
                    icon={<Icon name="list" />}
                    title={inputSearchValue ? t('ticket.charts.contingents.list.empty-search') : t('ticket.charts.contingents.list.empty')}
                    labelButton={inputSearchValue ? null : t('ticket.charts.contingents.list.add-contingent')}
                    onClick={() => history.push(`/ticket/O${organization.id}/charts/${chartId}/contingents/new`)}
                />
            )}
        </>
    );
}
